import { UseFormParams } from 'src/hooks'

import { LegalUnitEstablishment } from '../../../types'
// Rule being triggered because the parent folder is components, should be elements
// eslint-disable-next-line @billy/shine-accounting/consistent-alias-imports -- ../components is this step's own components folder, not src/components
import { AddressingLineFormat } from '../components/AddressingLineSelector/types/frAddressingLinesFormats'
import { CompanyInfoSchema } from './getCompanyInfoValidationSchema'

export const getDefaultCompanyInfoValues = (
  legalUnitEstablishment?: LegalUnitEstablishment,
): UseFormParams<CompanyInfoSchema>['defaultValues'] => {
  const hiddenDefaults = {
    formType: 'auto-full',
    addressingLineFormat: AddressingLineFormat.SIREN,
  } as const

  if (!legalUnitEstablishment) {
    return hiddenDefaults
  }

  const sirenRetrocompatible = legalUnitEstablishment.establishmentIdentifier?.slice(0, 9) ?? null

  return {
    ...hiddenDefaults,
    accountHolderFirstName: legalUnitEstablishment.accountHolderFirstName,
    accountHolderLastName: legalUnitEstablishment.accountHolderLastName,
    companyAddress: legalUnitEstablishment.companyAddress,
    companyCity: legalUnitEstablishment.companyCity,
    companyName: legalUnitEstablishment.companyName,
    companyZipCode: legalUnitEstablishment.companyZipCode,
    companyRegistrationNumber: sirenRetrocompatible,
  }
}
